import { memo } from 'react';
import { Link } from 'react-router-dom';
import {
  Grid, Stack, Typography, Button as MuiButton,
} from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { HomeSection } from '@client/components/common/HomeSection';

const useStyles = makeStyles()((theme) => ({
  root: {
    backgroundColor: theme.palette.secondary.xlight,
    marginTop: theme.spacing(2),
    padding: theme.spacing(4, 0),

    [theme.breakpoints.up('md')]: {
      marginTop: theme.spacing(4),
      padding: theme.spacing(6, 0),
    },
  },
}));

export const ConsultationCTA = memo(() => {
  const { classes } = useStyles();

  return (
    <HomeSection rootClassName={classes.root}>
      <div>
        <Grid
          container
          alignItems="center"
        >
          <Grid
            item
            md={5}
          >
            <Stack spacing={3}>
              <Stack spacing={2}>
                <Typography
                  variant="h6"
                  sx={{ color: 'secondary.dark' }}
                >
                  How does Side Door make money?
                </Typography>

                <Typography
                  variant="subtitle1"
                  sx={{ color: 'secondary.dark' }}
                >
                  Side Door takes 10% of net settlement revenue after taxes and P.R.O. remittance (if/when applicable),
                  plus a $3 processing fee for the ticket purchaser.
                </Typography>

                <Typography
                  variant="subtitle1"
                  sx={{ color: 'secondary.dark' }}
                >
                  Have questions about features or pricing?
                </Typography>
              </Stack>

              <div>
                <MuiButton
                  id="sda-for-artists-and-hosts-consultation-button"
                  component={Link}
                  to="consultation"
                  variant="outlined"
                  color="secondary_dark"
                  size="large"
                >
                  Book a Consultation Call
                </MuiButton>
              </div>
            </Stack>
          </Grid>
        </Grid>
      </div>
    </HomeSection>
  );
});
